import { useStaticCallback } from '@sparemin/blockhead';
import { useEffect, useRef } from 'react';
import { useEditSceneModalStateContext } from './state';

export default function useAdjustCropKeyBindings() {
  const {
    dispatch,
    state: { controlPanelMode },
  } = useEditSceneModalStateContext();

  const controlPanelModeRef = useRef(controlPanelMode);

  // Keep ref in sync with current value
  useEffect(() => {
    controlPanelModeRef.current = controlPanelMode;
  }, [controlPanelMode]);

  const staticOnKeyDown = useStaticCallback((e: KeyboardEvent) => {
    if (controlPanelModeRef.current !== 'adjust-crop') {
      return;
    }

    if (e.key === 'Escape') {
      e.stopPropagation();
      e.preventDefault();

      dispatch({
        type: 'adjust-crop-cancel',
      });
    }
  });

  useEffect(() => {
    document.addEventListener('keydown', staticOnKeyDown, true); // Use capture phase

    return () => {
      document.removeEventListener('keydown', staticOnKeyDown, true);
    };
  }, [staticOnKeyDown]);
}
